/* Res-T Produktseite: Galerie, Kaufbox mit Größenrechner und Zu-zweit-Set, Warenkorb, Sticky-Leiste, Abschnitte, Vorher/Nachher (nur Vorschau). */
(function () {
  'use strict';
  var R = window.RT || {};
  /* Texte aus den Sprachdateien (snippets/rt-i18n-js.liquid), Platzhalter {name} */
  var TT = R.t || {};
  var tf = function (k, o) { var s = TT[k] != null ? String(TT[k]) : k; if (o) { for (var p in o) s = s.split('{' + p + '}').join(o[p]); } return s; };
  var LANG = (document.documentElement.lang || 'de').slice(0, 2);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* Preise im Format des Shops (CHF oder EUR je nach Markt), wie der Liquid-Filter money */
  var money = function (cents) {
    var fmt = R.moneyFormat || '{{amount}}', c = Math.round(+cents || 0);
    var num = function (dec, th, ds) {
      var s = (c / 100).toFixed(dec).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (s[1] ? ds + s[1] : '');
    };
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      return k === 'amount_no_decimals' ? num(0, ',', '.')
        : k === 'amount_with_comma_separator' ? num(2, '.', ',')
        : k === 'amount_no_decimals_with_comma_separator' ? num(0, '.', ',')
        : k === 'amount_with_apostrophe_separator' ? num(2, "'", '.')
        : k === 'amount_no_decimals_with_space_separator' ? num(0, ' ', '')
        : k === 'amount_with_space_separator' ? num(2, ' ', ',')
        : num(2, ',', '.');
    });
    var d = document.createElement('div'); d.innerHTML = out; return d.textContent;
  };
  var ROOT = (R.root || '/').replace(/\/$/, '');
  var LIVE = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  var icon = function (n) { var t = $('#rt-icons'); var e = t && t.content.querySelector('[data-i="' + n + '"]'); return e ? e.innerHTML : ''; };
  var SIZES = ['S', 'M', 'L', 'XL', '2XL'];
  var PCT = 0;

  /* Shopify-Vorschauleiste: fixe Elemente rücken darüber */
  function previewOffset() {
    var pb = document.getElementById('preview-bar-iframe') || $('.shopify-preview-bar') || $('#PBarNextFrameWrapper');
    var h = pb && pb.getBoundingClientRect().height > 0 && getComputedStyle(pb).display !== 'none' ? Math.round(pb.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pv', h + 'px');
  }
  previewOffset(); setTimeout(previewOffset, 1500); setTimeout(previewOffset, 4000); window.addEventListener('resize', previewOffset);

  /* Topbar: mobil rotierend */
  var tb = $$('[data-rt-topbar] p');
  if (tb.length) {
    var ti = 0; tb[0].classList.add('is-on');
    setInterval(function () { tb[ti].classList.remove('is-on'); ti = (ti + 1) % tb.length; tb[ti].classList.add('is-on'); }, 3500);
  }

  /* ---------- Galerie ---------- */
  var gal = $('[data-rt-gal]');
  var track = gal && $('[data-rt-track]', gal);
  function visSlides() { return track ? $$('.rt-gal__slide', track).filter(function (s) { return !s.hidden; }) : []; }
  function visThumbs() { return gal ? $$('.rt-gal__thumb', gal).filter(function (t) { return !t.hidden; }) : []; }
  function galIndex() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
  function galGo(i, smooth) {
    var sl = visSlides(); if (!sl.length) return;
    i = (i + sl.length) % sl.length;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function galSync() {
    var i = galIndex(), th = visThumbs();
    th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    var cur = th[i]; if (cur) { var box = cur.parentNode; if (box.scrollHeight > box.clientHeight || box.scrollWidth > box.clientWidth) cur.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
    var ci = $('[data-rt-gal-i]', gal), cn = $('[data-rt-gal-n]', gal);
    if (ci) ci.textContent = i + 1; if (cn) cn.textContent = visSlides().length;
  }
  function galColor(farbe) {
    if (!gal) return;
    $$('[data-farbe]', gal).forEach(function (el) { el.hidden = el.dataset.farbe !== farbe && el.dataset.farbe !== '*'; });
    galGo(0, false); galSync();
  }
  if (gal) {
    var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(galSync, 60); }, { passive: true });
    gal.addEventListener('click', function (e) {
      var t = e.target.closest('.rt-gal__thumb'); if (t) { galGo(visThumbs().indexOf(t)); return; }
      if (e.target.closest('[data-rt-gal-prev]')) galGo(galIndex() - 1);
      if (e.target.closest('[data-rt-gal-next]')) galGo(galIndex() + 1);
    });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); galGo(galIndex() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); galGo(galIndex() - 1); } });
    window.addEventListener('resize', function () { galGo(galIndex(), false); });
    galSync();
  }

  /* ---------- Kaufbox ---------- */
  var buy = $('[data-rt-buy]');
  PCT = buy ? +(buy.dataset.pct || 0) : (R.setPercent || 0);
  $$('[data-rt-set-note]').forEach(function (el) { el.hidden = !PCT; if (PCT) el.textContent = tf('set_note', { p: PCT }); });
  var state = { farbe: null, groesse: null, menge: 1, farbe2: null, groesse2: null, addon: false };
  var findV = function (f, g) { return (R.variants || []).filter(function (v) { return v.farbe === f && v.groesse === g; })[0]; };
  var val = function (name) { var x = buy && $('input[name="' + name + '"]:checked', buy); return x ? x.value : null; };

  function totalCents() {
    var p = R.price || +buy.dataset.price;
    var t = state.menge === 2 ? +buy.dataset.set : p;
    if (state.addon && R.kartusche) t += R.kartusche.price;
    return t;
  }
  function ready() { return !!state.groesse && (state.menge === 1 || !!state.groesse2); }

  function readState() {
    state.farbe = val('rt-farbe');
    state.groesse = val('rt-groesse');
    state.menge = +(val('rt-menge') || 1);
    state.farbe2 = val('rt-farbe2') || state.farbe;
    state.groesse2 = val('rt-groesse2');
    var a = $('[data-rt-addon]', buy); state.addon = !!(a && a.checked);
  }

  function update(src) {
    readState();
    var lab = $('[data-rt-farbe-label]', buy); if (lab) lab.textContent = state.farbe;
    var sl = $('[data-rt-size-label]', buy); if (sl) sl.textContent = state.groesse || tf('choose');
    var hint = $('[data-rt-size-hint]', buy), sf = $('[data-rt-sizefield]', buy);
    if (state.groesse && (state.menge === 1 || state.groesse2)) { sf.classList.remove('is-error'); hint.hidden = true; }
    $$('.rt-table tr[data-size]').forEach(function (tr) { tr.classList.toggle('is-on', tr.dataset.size === state.groesse); });
    $$('.rt-size', buy).forEach(function (el) {
      var v0 = findV(state.farbe, el.dataset.size), out = !v0 || v0.ok === false;
      el.classList.toggle('is-out', out); var inp = $('input', el); if (inp) inp.disabled = out;
      el.title = out ? tf('out_in', { c: state.farbe }) : '';
      if (out && inp && inp.checked) { inp.checked = false; state.groesse = null; if (sl) sl.textContent = tf('choose'); }
    });
    $$('input[name="rt-groesse2"]', buy).forEach(function (inp) {
      var v2 = findV(state.farbe2, inp.value), out = !v2 || v2.ok === false;
      inp.disabled = out; inp.parentNode.classList.toggle('is-out', out);
      if (out && inp.checked) { inp.checked = false; state.groesse2 = null; }
    });
    var sec = $('[data-rt-second]', buy); if (sec) sec.hidden = state.menge !== 2;
    // zweite Größe übernimmt beim Öffnen die erste
    if (state.menge === 2 && !state.groesse2 && state.groesse && src === 'menge') {
      var r2 = $('input[name="rt-groesse2"][value="' + state.groesse + '"]', buy); if (r2 && !r2.disabled) { r2.checked = true; state.groesse2 = state.groesse; }
    }
    if (src === 'farbe') {
      var f2 = $('input[name="rt-farbe2"][value="' + state.farbe + '"]', buy); if (f2 && state.menge === 1) f2.checked = true;
      galColor(state.farbe);
    }
    var tot = money(totalCents());
    $$('[data-rt-total]').forEach(function (el) { el.textContent = tot; });
    var cta = $('[data-rt-cta-label]', buy);
    if (cta) cta.textContent = !state.groesse ? tf('size_pick') : (state.menge === 2 && !state.groesse2 ? tf('size2_pick') : (state.menge === 2 ? tf('add2') : tf('add')));
    // Sticky
    var v = state.groesse && findV(state.farbe, state.groesse);
    var meta = $('[data-rt-sticky-meta]');
    if (meta) meta.textContent = state.farbe + ', ' + (state.groesse ? tf('size_x', { s: state.groesse }) : tf('size_pick')) + (state.menge === 2 ? tf('two_pcs') : '');
    var sLab = $('[data-rt-sticky-label]'); if (sLab) sLab.textContent = ready() ? tf('add') : tf('size_pick');
    var vimg = (R.variants || []).filter(function (x) { return x.farbe === state.farbe; })[0];
    var si = $('[data-rt-sticky-img]'); if (si && vimg && vimg.img) si.src = vimg.img;
    if (v && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
  }

  function sizeError() {
    var sf = $('[data-rt-sizefield]', buy); if (!sf) return;
    sf.classList.add('is-error', 'is-shake');
    var hint = $('[data-rt-size-hint]', buy);
    hint.textContent = !state.groesse ? tf('err_size') : tf('err_size2'); hint.hidden = false;
    setTimeout(function () { sf.classList.remove('is-shake'); }, 450);
    var y = sf.getBoundingClientRect().top + window.scrollY - 110;
    if (Math.abs(window.scrollY - y) > 80) window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* Größenrechner */
  // Gewicht entscheidet, weil Res-T lang geschnitten ist. Nur wenn die Körpergröße 3 oder mehr Größen
  // über dem Gewicht liegt, eine Größe mehr (Regel von Marco, 28.10.2026)
  function recommend(h, w) {
    var hi = h < 170 ? 0 : h < 180 ? 1 : h < 190 ? 2 : h <= 200 ? 3 : 4;
    var wi = w < 75 ? 0 : w < 85 ? 1 : w < 92.5 ? 2 : w <= 110 ? 3 : 4;
    return { i: hi - wi >= 3 ? wi + 1 : wi, wi: wi, hi: hi };
  }
  // pick: nach dem Schieben die empfohlene Größe gleich auswählen
  function finderUpdate(pick) {
    var h = +$('[data-rt-f-h]', buy).value, w = +$('[data-rt-f-w]', buy).value;
    $('[data-rt-out-h]', buy).textContent = h + ' cm';
    $('[data-rt-out-w]', buy).textContent = w + ' kg';
    var r = recommend(h, w), s = SIZES[r.i];
    var inp = $('input[name="rt-groesse"][value="' + s + '"]', buy), out = !inp || inp.disabled;
    if (pick && !out && !inp.checked) { inp.checked = true; update('groesse'); }
    // Empfohlene Größe ausverkauft: keine andere Größe ausgewählt lassen
    var cur = $('input[name="rt-groesse"]:checked', buy);
    if (pick && out && cur) { cur.checked = false; update('groesse'); }
    var sel = !out && inp.checked;
    $('[data-rt-f-res]', buy).innerHTML = tf(out ? 'finder_out' : sel ? 'finder_sel' : 'finder_res', { s: s });
    var why = $('[data-rt-f-why]', buy);
    why.textContent = r.i !== r.wi ? tf('finder_up', { w: SIZES[r.wi], h: SIZES[r.hi] }) : r.hi !== r.i ? tf('finder_why', { h: SIZES[r.hi] }) : '';
    why.hidden = !why.textContent;
    var b = $('[data-rt-f-take]', buy); b.textContent = tf('finder_take', { s: s }); b.dataset.size = s; b.hidden = out || sel;
    $$('.rt-size', buy).forEach(function (el) { el.classList.toggle('is-rec', el.dataset.size === s); });
  }

  if (buy) {
    buy.addEventListener('change', function (e) {
      var n = e.target.name;
      update(n === 'rt-farbe' ? 'farbe' : n === 'rt-menge' ? 'menge' : n);
    });
    var ft = $('[data-rt-finder-toggle]', buy), fp = $('[data-rt-finder]', buy);
    ft && ft.addEventListener('click', function () {
      fp.hidden = !fp.hidden; ft.setAttribute('aria-expanded', String(!fp.hidden));
      if (!fp.hidden) finderUpdate(); else $$('.rt-size', buy).forEach(function (el) { el.classList.remove('is-rec'); });
    });
    $$('[data-rt-f-h], [data-rt-f-w]', buy).forEach(function (r) { r.addEventListener('input', function () { finderUpdate(true); }); });
    var take = $('[data-rt-f-take]', buy);
    take && take.addEventListener('click', function () {
      var r = $('input[name="rt-groesse"][value="' + take.dataset.size + '"]', buy);
      if (r) { r.checked = true; update('groesse'); finderUpdate(); }
    });
    // Startzustand aus ?variant=
    var pv = new URL(location.href).searchParams.get('variant');
    var pre = pv && (R.variants || []).filter(function (v) { return String(v.id) === pv; })[0];
    if (pre) {
      var rf = $('input[name="rt-farbe"][value="' + pre.farbe + '"]', buy); if (rf) rf.checked = true;
      var rg = $('input[name="rt-groesse"][value="' + pre.groesse + '"]', buy); if (rg) rg.checked = true;
    } else {
      // ?farbe=Blau von der Startseite: nur die Farbe vorwählen, die Größe wählt der Kunde
      var pf = new URL(location.href).searchParams.get('farbe');
      var rpf = pf && window.CSS && CSS.escape ? $('input[name="rt-farbe"][value="' + CSS.escape(pf) + '"]', buy) : null;
      if (rpf) rpf.checked = true;
    }
    update('farbe');

    // ETA: 1 bis 2 Werktage Bearbeitung + Lieferzeit des Landes (snippets/rt-ship.liquid)
    var addWD = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var g = d.getDay(); if (g !== 0 && g !== 6) n--; } return d; };
    var dm = function (d) { return LANG === 'de' ? d.getDate() + '.' + (d.getMonth() + 1) + '.' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); };
    var range = function (a, b) { if (a.getMonth() !== b.getMonth()) return dm(a) + '–' + dm(b); return LANG === 'de' ? a.getDate() + '.–' + dm(b) : a.getDate() + '–' + dm(b); };
    var eta = $('.rt-eta', buy), lo = eta ? +eta.dataset.min || 1 : 1, hi = eta ? +eta.dataset.max || 3 : 3;
    var now = new Date(), d0 = $('[data-rt-d0]', buy), d1 = $('[data-rt-d1]', buy), d2 = $('[data-rt-d2]', buy);
    if (d0) d0.textContent = tf('today') + ', ' + dm(now);
    if (d1) d1.textContent = range(addWD(now, 1), addWD(now, 2));
    if (d2) d2.textContent = range(addWD(now, 1 + lo), addWD(now, 2 + hi));
  }

  function addToCart(btn) {
    readState();
    if (!ready()) { sizeError(); return; }
    var v1 = findV(state.farbe, state.groesse);
    var items = [];
    if (state.menge === 2) {
      var v2 = findV(state.farbe2, state.groesse2);
      if (v2 && v1 && v2.id === v1.id) items.push({ id: v1.id, quantity: 2 });
      else { items.push({ id: v1.id, quantity: 1 }); if (v2) items.push({ id: v2.id, quantity: 1 }); }
    } else items.push({ id: v1.id, quantity: 1 });
    if (state.addon && R.kartusche && R.kartusche.id) items.push({ id: R.kartusche.id, quantity: 1 });
    btn.disabled = true; busy(true);
    api(ROOT + '/cart/add.js', { items: items })
      .then(getCart).then(function (c) { render(c); open(); })
      .catch(function (e) { busy(false); alert(tf('add_err') + e.message); })
      .then(function () { btn.disabled = false; });
  }
  var addBtn = buy && $('[data-rt-add]', buy);
  addBtn && addBtn.addEventListener('click', function () { addToCart(addBtn); });

  /* ---------- Warenkorb ---------- */
  function api(url, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(url, opt).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); });
  }
  var getCart = function () { return api(ROOT + '/cart.js'); };
  var isRT = function (it) { return it.product_id === R.product; };
  var img = function (u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160) : ''; };

  /* Warenkorb-Beträge in der Währung des Warenkorbs (nach einem Länderwechsel kann sie kurz von der Seite abweichen) */
  var cartCur = null;
  var cm = function (c) {
    var page = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!cartCur || !page || cartCur === page) return money(c);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cartCur }).format(c / 100); } catch (e) { return money(c); }
  };
  var vOf = function (it) { return (R.variants || []).filter(function (v) { return v.id === it.variant_id; })[0]; };

  /* fake = Zu-zweit-Rabatt nur angezeigt (Vorschau ohne angelegten Rabatt im Admin) */
  function lineHTML(it, fake) {
    var orig = it.original_line_price, fin = it.final_line_price;
    if (fake && isRT(it)) fin = Math.round(fin * (100 - PCT) / 100);
    var v = isRT(it) && vOf(it);
    var meta = v ? v.farbe + ', ' + tf('size_x', { s: v.groesse }) : (it.variant_title || '');
    return '<div class="rt-ci"><div class="rt-ci__img"><img src="' + img(it.image, 200) + '" alt="" width="80" height="80"></div>'
      + '<div><div class="rt-ci__top"><b>' + it.product_title + '</b><span>' + (fin < orig ? '<s>' + cm(orig) + '</s>' + cm(fin) : cm(fin)) + '</span></div>'
      + (meta ? '<p class="rt-ci__meta">' + meta + '</p>' : '')
      + '<div class="rt-ci__ctl"><div class="rt-qty"><button type="button" data-q="-1" data-key="' + it.key + '" data-n="' + it.quantity + '" aria-label="' + tf('less') + '">' + icon('minus') + '</button><span>' + it.quantity + '</span><button type="button" data-q="1" data-key="' + it.key + '" data-n="' + it.quantity + '" aria-label="' + tf('more') + '">' + icon('plus') + '</button></div>'
      + '<button type="button" class="rt-ci__rm" data-q="rm" data-key="' + it.key + '">' + tf('remove') + '</button></div></div></div>';
  }

  /* Rabatte, die Shopify tatsächlich berechnet (automatische Rabatte, Codes), nach Titel zusammengefasst */
  function realDiscounts(cart) {
    var map = {}, add = function (title, amt) { if (/zu-zweit/i.test(title) && PCT) title = tf('set_label', { p: PCT }); if (amt > 0) map[title] = (map[title] || 0) + amt; };
    cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (d) { add(d.discount_application.title, d.amount); }); });
    (cart.cart_level_discount_applications || []).forEach(function (d) { add(d.title, d.total_allocated_amount); });
    return Object.keys(map).map(function (k) { return { title: k, amount: map[k] }; });
  }

  function render(cart) {
    var cnt = cart.item_count;
    cartCur = cart.currency;
    $$('[data-rt-count]').forEach(function (el) { el.textContent = cnt; el.hidden = !cnt; });
    var html;
    if (!cnt) {
      html = '<div class="rt-cartui__scroll"><div class="rt-cart-empty"><p>' + tf('empty') + '</p><a class="rt-btn rt-btn--orange" href="' + (R.url || '/') + '" data-rt-close>' + tf('to_rest') + '</a></div></div>';
    } else {
      var rtQty = 0, rtSum = 0, hasK = false;
      cart.items.forEach(function (it) { if (isRT(it)) { rtQty += it.quantity; rtSum += it.final_line_price; } if (R.kartusche && it.variant_id === R.kartusche.id) hasK = true; });
      var real = realDiscounts(cart);
      var setOn = PCT > 0 && rtQty >= 2;
      var fake = setOn && !real.length && !LIVE;
      var discRows = fake ? [{ title: tf('set_label', { p: PCT }), amount: Math.round(rtSum * PCT / 100) }] : real;
      var save = discRows.reduce(function (s, d) { return s + d.amount; }, 0);
      var total = fake ? cart.total_price - save : cart.total_price;
      var lines = cart.items.slice().sort(function (a, b) { return (isRT(b) ? 1 : 0) - (isRT(a) ? 1 : 0); }).map(function (it) { return lineHTML(it, fake); }).join('');
      var up = '';
      if (rtQty === 1 && PCT > 0) {
        up += '<p class="rt-up__t">' + tf('up2_t') + '</p><div class="rt-up"><img src="' + img(cart.items.filter(isRT)[0].image, 160) + '" alt=""><div><b>' + tf('up2_b', { p: PCT }) + '</b><small>' + tf('up2_s', { a: money(Math.round(R.price * (100 - PCT) / 100)), b: money(R.price) }) + '</small></div><button type="button" data-rt-dup="' + cart.items.filter(isRT)[0].key + '" data-n="1">' + icon('plus') + tf('up2_btn') + '</button></div>';
      } else if (!hasK && R.kartusche && R.kartusche.id) {
        up += '<p class="rt-up__t">' + tf('upk_t') + '</p><div class="rt-up"><img src="' + R.kartusche.img + '" alt=""><div><b>' + tf('upk_b') + '</b><small>' + tf('upk_s') + '</small></div><button type="button" data-rt-addv="' + R.kartusche.id + '">' + icon('plus') + money(R.kartusche.price) + '</button></div>';
      }
      var note = rtQty && hasK ? tf('note_k') : (setOn && save ? tf('note_set', { p: PCT }) : tf('note_ret'));
      var shipTxt = R.ship ? tf('ship_to', { to: R.ship.to, cost: money(R.ship.cents) }) : tf('ship_co');
      html = '<p class="rt-note">' + icon(setOn && save ? 'check' : (rtQty && hasK ? 'truck' : 'return')) + '<span>' + note + '</span></p>'
        + '<div class="rt-cartui__scroll">' + lines + up + '</div>'
        + '<div class="rt-cartui__foot"><div class="rt-sum">'
        + '<p><span>' + tf('subtotal') + '</span><span>' + cm(cart.original_total_price) + '</span></p>'
        + discRows.map(function (d) { return '<p class="is-save"><span>' + d.title + '</span><span>−' + cm(d.amount) + '</span></p>'; }).join('')
        + '<p class="is-total"><span>' + tf('total') + '</span><span>' + cm(total) + '</span></p>'
        + '<small>' + shipTxt + '</small></div>'
        + '<a class="rt-cta rt-pay-cta" href="' + ROOT + '/checkout"><span>' + tf('checkout') + '</span><span class="rt-cta__price">' + cm(total) + '</span></a>'
        + '<div class="rt-payrow"><span class="rt-sr">' + tf('paytypes') + '</span>' + icon('pay') + '</div></div>';
    }
    $$('[data-rt-cart]').forEach(function (el) { el.innerHTML = html; el.classList.remove('is-busy'); });
  }
  function busy(on) { $$('[data-rt-cart]').forEach(function (el) { el.classList.toggle('is-busy', on); }); }
  function refresh(p) { busy(true); return (p || Promise.resolve()).then(getCart).then(render).catch(function (e) { busy(false); console.warn(e); }); }

  var drawer = $('#rt-drawer'), lastFocus = null;
  function open() { if (!drawer) return; lastFocus = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; document.documentElement.classList.add('rt-drawer-open'); setTimeout(function () { var c = $('.rt-drawer__close', drawer); c && c.focus(); }, 60); }
  function close() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; document.documentElement.classList.remove('rt-drawer-open'); lastFocus && lastFocus.focus && lastFocus.focus(); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rt-open-cart]')) { e.preventDefault(); refresh(); open(); return; }
    if (e.target.closest('[data-rt-close]')) { close(); return; }
    var q = e.target.closest('[data-q]');
    if (q) { var n = q.dataset.q === 'rm' ? 0 : Math.max(0, (+q.dataset.n) + (+q.dataset.q)); refresh(api(ROOT + '/cart/change.js', { id: q.dataset.key, quantity: n })); return; }
    var d = e.target.closest('[data-rt-dup]');
    if (d) { refresh(api(ROOT + '/cart/change.js', { id: d.dataset.rtDup, quantity: 2 })); return; }
    var av = e.target.closest('[data-rt-addv]');
    if (av) { refresh(api(ROOT + '/cart/add.js', { items: [{ id: +av.dataset.rtAddv, quantity: 1 }] })); return; }
    var sb = e.target.closest('[data-rt-scroll-buy]');
    if (sb && buy) {
      e.preventDefault();
      var tgt = $('[data-rt-sizefield]', buy) || buy;
      window.scrollTo({ top: tgt.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      return;
    }
    if (e.target.closest('[data-rt-cookies]')) { e.preventDefault(); if (window.privacyBanner && privacyBanner.showPreferences) privacyBanner.showPreferences(); return; }
    var oa = e.target.closest('[data-rt-open-acc]');
    if (oa) { var dd = $('details[data-acc="' + oa.dataset.rtOpenAcc + '"]'); if (dd) { e.preventDefault(); dd.open = true; window.scrollTo({ top: dd.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' }); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close(); });

  /* Warenkorb-Seite: gleiche Darstellung wie rechts */
  if ($('[data-rt-cartpage]')) refresh();

  /* Einfache Produktseite (Kartuschen, Paddel …): Variante, Menge, In den Warenkorb */
  $$('[data-rt-pform]').forEach(function (f) {
    var vs = []; try { vs = JSON.parse($('[data-rt-pvariants]', f).textContent); } catch (e) {}
    var idIn = $('[data-rt-pid]', f), qIn = $('[data-rt-pqty]', f), btn = $('[data-rt-padd]', f), lab = $('[data-rt-plabel]', f);
    var priceEl = $('[data-rt-pprice]');
    var pick = function () {
      var sel = $$('[data-rt-popt]', f).map(function (s) { return s.value; });
      var v = vs.filter(function (x) { return sel.every(function (o, i) { return x.options[i] === o; }); })[0];
      if (!v) { btn.disabled = true; lab.textContent = tf('unavailable'); return; }
      idIn.value = v.id; btn.disabled = !v.available; lab.textContent = v.available ? tf('add') : tf('soldout');
      if (priceEl) priceEl.textContent = v.price;
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    };
    f.addEventListener('change', function (e) { if (e.target.matches('[data-rt-popt]')) pick(); });
    $$('[data-rt-pq]', f).forEach(function (b) { b.addEventListener('click', function () { qIn.value = Math.max(1, Math.min(20, (+qIn.value || 1) + (+b.dataset.rtPq))); }); });
    f.addEventListener('submit', function (e) {
      e.preventDefault(); btn.disabled = true; busy(true);
      api(ROOT + '/cart/add.js', { items: [{ id: +idIn.value, quantity: Math.max(1, +qIn.value || 1) }] })
        .then(getCart).then(function (c) { render(c); open(); })
        .catch(function (er) { busy(false); alert(tf('add_err') + er.message); })
        .then(function () { btn.disabled = false; });
    });
  });

  /* Startseite: Kartuschen direkt in den Warenkorb */
  $$('[data-rt-quickadd]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true; busy(true);
      api(ROOT + '/cart/add.js', { items: [{ id: +b.dataset.rtQuickadd, quantity: 1 }] })
        .then(getCart).then(function (c) { render(c); open(); })
        .catch(function (e) { busy(false); alert(tf('add_err') + e.message); })
        .then(function () { b.disabled = false; });
    });
  });

  /* Startseite: Farbe in der Produktkarte wechselt Bild und Link */
  $$('[data-rt-card]').forEach(function (card) {
    var links = $$('[data-rt-card-link]', card);
    links.forEach(function (a) { a.dataset.base = a.getAttribute('href'); });
    card.addEventListener('change', function (e) {
      if (e.target.name !== 'rt-card-farbe') return;
      var f = e.target.value;
      $$('img[data-farbe]', card).forEach(function (im) { im.hidden = im.dataset.farbe !== f; });
      var lab = $('[data-rt-card-farbe]', card); if (lab) lab.textContent = f;
      links.forEach(function (a) { var u = new URL(a.dataset.base, location.href); u.searchParams.set('farbe', f); a.href = u.pathname + u.search + u.hash; });
      previewLinks();
    });
  });

  /* Videos mit Autoplay: laufen nur sichtbar, Pause-Knopf, keine Bewegung bei reduzierter Bewegung */
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-rt-autovideo]').forEach(function (v) {
    var btn = v.parentNode.querySelector('[data-rt-vtoggle]'), paused = reduce;
    var setBtn = function () { if (!btn) return; btn.classList.toggle('is-paused', v.paused); btn.setAttribute('aria-label', v.paused ? tf('v_play') : tf('v_pause')); };
    v.addEventListener('play', setBtn); v.addEventListener('pause', setBtn); setBtn();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !paused) { v.play().catch(function () {}); } else { v.pause(); }
      }, { threshold: .3 }).observe(v);
    }
    btn && btn.addEventListener('click', function () {
      if (v.paused) { paused = false; v.play().catch(function () {}); } else { paused = true; v.pause(); }
    });
  });

  /* Sport-Kacheln: kurze Clips laden erst nahe am Bildschirm und laufen nur sichtbar */
  var tileVids = $$('[data-rt-tilevideo]');
  if (tileVids.length && 'IntersectionObserver' in window && !reduce) {
    var tio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.src) v.src = v.dataset.src;
          v.play().then(function () { v.classList.add('is-playing'); }).catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: .35 });
    tileVids.forEach(function (v) { tio.observe(v); });
  }

  /* Zitat: Wörter färben sich beim Scrollen der Reihe nach ein */
  $$('[data-rt-scrolltext]').forEach(function (q) {
    var hl = new RegExp('^[„"]?(' + (q.dataset.hl || '-').split('|').map(function (s) { return s.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).filter(Boolean).join('|') + ')', 'i');
    q.innerHTML = q.textContent.split(/(\s+)/).map(function (w) {
      return /^\s+$/.test(w) ? w : '<span class="w' + (hl.test(w) ? ' hl' : '') + '">' + w + '</span>';
    }).join('');
    var ws = $$('.w', q);
    if (reduce) { ws.forEach(function (w) { w.classList.add('is-on'); }); return; }
    var tick = function () {
      var r = q.getBoundingClientRect(), vh = window.innerHeight;
      var k = Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height + vh * .35)));
      var n = Math.round(k * ws.length);
      ws.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    };
    window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); tick();
  });

  /* Über uns: Linie der Zeitleiste füllt sich beim Scrollen, Punkte werden aktiv */
  $$('[data-rt-weg]').forEach(function (list) {
    var items = $$('.rt-weg__item', list);
    var tick = function () {
      var r = list.getBoundingClientRect(), mid = window.innerHeight * .6;
      var k = Math.min(1, Math.max(0, (mid - r.top) / Math.max(1, r.height)));
      list.style.setProperty('--fill', reduce ? 1 : k);
      items.forEach(function (it) { it.classList.toggle('is-on', reduce || it.getBoundingClientRect().top < mid); });
    };
    window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); tick();
  });

  /* Vorschau-Links (?view=rest) setzt snippets/rt-preview-shim.liquid */
  function previewLinks() { if (window.rtPreviewLinks) window.rtPreviewLinks(); }

  /* ---------- Social Proof: Stimmen wechseln ---------- */
  var pq = $$('.rt-proof__q > span');
  if (pq.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var pi = 0;
    setInterval(function () { pq[pi].classList.remove('is-on'); pi = (pi + 1) % pq.length; pq[pi].classList.add('is-on'); }, 4200);
  }
  var proof = $('[data-rt-proof]');
  proof && proof.addEventListener('click', function (e) {
    var t = $('#rt-stimmen'); if (!t) return;
    e.preventDefault(); window.scrollTo({ top: t.querySelector('.rt-h2').getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
  });

  /* ---------- Sportarten-Leiste: Name beim Zeigen ---------- */
  var spLab = $('[data-rt-sport-label]'), spDef = spLab ? spLab.textContent : '';
  $$('.rt-sports__i').forEach(function (b) {
    var on = function () { $$('.rt-sports__i').forEach(function (x) { x.classList.toggle('is-on', x === b); }); spLab.textContent = b.dataset.name; };
    b.addEventListener('mouseenter', on); b.addEventListener('focus', on); b.addEventListener('click', on);
  });
  var spBox = $('[data-rt-sports]');
  spBox && spBox.addEventListener('mouseleave', function () { if (spBox.contains(document.activeElement)) return; $$('.rt-sports__i').forEach(function (x) { x.classList.remove('is-on'); }); spLab.textContent = spDef; });

  /* ---------- Sticky-Leiste ---------- */
  var sticky = $('[data-rt-sticky]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    var ctaVis = true, endVis = false;
    var setSticky = function () {
      var on = !ctaVis && !endVis && addBtn.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on));
      var b = $('[data-rt-sticky-btn]', sticky); if (b) b.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('rt-sticky-on', on);
    };
    new IntersectionObserver(function (es) { ctaVis = es[0].isIntersecting; setSticky(); }).observe(addBtn);
    var endEl = $('.rt-final') || $('.rt-footer');
    endEl && new IntersectionObserver(function (es) { endVis = es[0].isIntersecting; setSticky(); }).observe(endEl);
    window.addEventListener('scroll', function () { if (!ctaVis) setSticky(); }, { passive: true });
    $('[data-rt-sticky-btn]', sticky).addEventListener('click', function () {
      readState();
      if (ready()) addToCart(this); else sizeError();
    });
  }

  /* ---------- Video: spielt nur sichtbar ---------- */
  var vids = $$('[data-rt-video]'), vt = $('[data-rt-video-toggle]'), userPaused = false;
  var activeVid = function () { return vids.filter(function (v) { return v.offsetParent !== null; })[0]; };
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = activeVid(); if (!v) return;
        if (en.isIntersecting && !userPaused) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: .35 });
    vio.observe($('.rt-trig__media'));
    vt && vt.addEventListener('click', function () {
      var v = activeVid(); if (!v) return;
      if (v.paused) { userPaused = false; v.play(); vt.classList.remove('is-paused'); vt.setAttribute('aria-label', tf('v_pause')); }
      else { userPaused = true; v.pause(); vt.classList.add('is-paused'); vt.setAttribute('aria-label', tf('v_play')); }
    });
  }

  /* ---------- Auftriebs-Balken mit Zählern ---------- */
  var meter = $('[data-rt-meter]');
  if (meter && 'IntersectionObserver' in window) {
    var mio = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      mio.disconnect(); meter.classList.add('is-in');
      $$('[data-n]', meter).forEach(function (el) {
        var to = +el.dataset.n, t0 = performance.now(), dur = 1400;
        (function step(t) { var k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); })(t0);
      });
    }, { threshold: .4 });
    mio.observe(meter);
  } else if (meter) { meter.classList.add('is-in'); $$('[data-n]', meter).forEach(function (el) { el.textContent = el.dataset.n; }); }

  /* ---------- Sport-Tabs ---------- */
  var tabs = $$('[data-rt-tab]');
  function selTab(t) {
    tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
    $$('[data-rt-pane]').forEach(function (p) { var on = p.dataset.rtPane === t.dataset.rtTab; p.hidden = !on; p.classList.toggle('is-on', on); });
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { selTab(t); });
    t.addEventListener('keydown', function (e) {
      var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null; if (j === null) return;
      e.preventDefault(); var n = tabs[(j + tabs.length) % tabs.length]; selTab(n); n.focus();
    });
  });

  /* ---------- Einblenden ---------- */
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var rv = $$('.rt-sport .rt-h2, .rt-sport__stage, .rt-voices .rt-h2, .rt-voices__grid, .rt-steps__head, .rt-steps__list, .rt-cmp__copy, .rt-cmp__table, .rt-made__img, .rt-made__copy, .rt-faq__side, .rt-faq__list, .rt-trig__copy, .rt-final__copy, .rt-shop .rt-h2, .rt-card, .rt-proof2__media, .rt-proof2__copy, .rt-tiles__head, .rt-tiles__list > li, .rt-story__img, .rt-story__copy, .rt-quote2__src');
    // Kacheln nacheinander einblenden
    $$('.rt-tiles__list > li, .rt-shop__grid > .rt-card').forEach(function (el, i, all) { el.style.transitionDelay = (Array.prototype.indexOf.call(el.parentNode.children, el) % 4) * 0.08 + 's'; });
    var rio = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight) { el.setAttribute('data-rt-reveal', ''); rio.observe(el); } });
  }

  /* ---------- Interview auf Über uns: YouTube (nocookie) erst nach dem Klick laden ---------- */
  $$('[data-rt-yt]').forEach(function (box) {
    var btn = $('[data-rt-yt-play]', box); if (!btn || !box.dataset.rtYt) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(box.dataset.rtYt) + '?autoplay=1&rel=0&playsinline=1' + (LANG === 'de' ? '&cc_load_policy=1&cc_lang_pref=de&hl=de' : '');
      f.title = btn.textContent.replace(/\s+/g, ' ').trim();
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
      box.innerHTML = ''; box.appendChild(f);
    });
  });

  /* ---------- Vorher / Nachher (nur solange das Theme nicht veröffentlicht ist) ---------- */
  var ba = $('[data-rt-ba]'), before = $('[data-rt-before]');
  if (LIVE) { ba && ba.remove(); before && before.remove(); ba = before = null; }
  function setView(v) {
    if (!before) return;
    var on = v === 'vorher';
    if (on === !before.hidden) return;
    var ratio = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    before.hidden = !on;
    document.body.classList.toggle('rt-before-on', on);
    $$('[data-rt-ba-btn]', ba).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.rtBaBtn === v)); });
    if (on) {
      var im = $('img', before);
      var go = function () { before.scrollTop = ratio * (before.scrollHeight - before.clientHeight); };
      if (im.complete) go(); else im.addEventListener('load', go, { once: true });
    }
  }
  if (ba) {
    ba.addEventListener('click', function (e) { var b = e.target.closest('[data-rt-ba-btn]'); if (b) setView(b.dataset.rtBaBtn); });
    document.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select') || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.key === 'v' || e.key === 'V') setView(before.hidden ? 'vorher' : 'nachher');
    });
    if (new URL(location.href).searchParams.get('ansicht') === 'vorher') setView('vorher');
  }
})();
